const Data = [
  {
    id: 1,
    category: "education",
    icon: "icon-graduation",
    year: "Aug 2017 – Apr 2021",
    title: "B.E. Computer Science Engineering",
    company: "PSG Institute of Technology and Applied Research, Coimbatore",
    desc: "Graduated with a GPA of 8.6/10, with a foundation in software engineering and distributed systems.",
  },
  {
    id: 2,
    category: "education",
    icon: "icon-graduation",
    year: "2015 – 2017",
    title: "Higher Secondary",
    company: "Malco Vidyalaya Matriculation Higher Secondary School",
    desc: "Completed with 97.2%.",
  },
  {
    id: 3,
    category: "education",
    icon: "icon-graduation",
    year: "2013 – 2015",
    title: "Secondary School",
    company: "Malco Vidyalaya Matriculation Higher Secondary School",
    desc: "Completed with 98.2%.",
  },
  {
    id: 4,
    category: "experience",
    icon: "icon-briefcase",
    year: "Aug 2025 – Present",
    title: "App Developer Programmer Analyst 2",
    company: "Citicorp Services India Pvt. Ltd.",
    desc: "Modernizing legacy Money Market applications in the QFXLM business line to improve performance and reliability. Automated the QFXLM data migration activity that previously required heavy manual effort.",
  },
  {
    id: 5,
    category: "experience",
    icon: "icon-briefcase",
    year: "Oct 2022 – Aug 2025",
    title: "Product Engineer – Microservices",
    company: "Temenos India Pvt. Ltd.",
    desc: "Partnered with leading banks to shape a fintech platform. Awarded for upgrading microservices from JDK 8 to JDK 11, unblocking the Annual Maintenance Release. Optimized the Party Microservice as the master data repository, reducing data access latency by 30%.",
  },
  {
    id: 6,
    category: "experience",
    icon: "icon-briefcase",
    year: "Apr 2022 – Sep 2022",
    title: "Associate Product Engineer – Microservices",
    company: "Temenos India Pvt. Ltd.",
    desc: "Directed FAMS go-live for the Finnish and Denmark markets, increasing active users by 25%. Enabled Funds Authorisation to run standalone without Transact/T24. Delivered a time-sensitive solution that avoided penalties and exceeded client revenue projections by 20%.",
  },
  {
    id: 7,
    category: "experience",
    icon: "icon-briefcase",
    year: "Feb 2021 – Apr 2022",
    title: "Software Engineer – Microservices",
    company: "Temenos India Pvt. Ltd.",
    desc: "Implemented Limited Service Mode for Funds Authorisation so banks can continue serving customers during planned Transact/T24 downtime.",
  },
];

export default Data;
